export const ACTION_FETCH = 'fetch';
export const BREADCRUMBS_TEXT = 'Организаторы программ на карте';
export const EMPTY_TEXT = 'К сожалению выбранным параметрам не удовлетворяет ни одно учреждение.';
export const MAX_COUNT = -1;
export const PAGE_TITLE = 'Карта организаций дополнительного образования';
export const PAGE_SIZE = 100;
export const PAGE_SEO_TITLE = PAGE_TITLE;
export const SHOW_ALL_PARAM = 'true';
export const SHOW_ALL_TEXT = 'Показать все филиалы';
export const STORE_MODULE_NAME = 'organizations-map';

export * from '../const';



// WEBPACK FOOTER //
// ./src/pages/organizations/map/const.ts